export const bulkCategoryProductsUpdate = (categories, parentCategoryId, subCategoryId, bulkProducts, isAllProductsSelected) => {
    const updatedCategories = categories.map((category) => {
        if (category.parentCategory.id === parentCategoryId
            && category.subCategories.find((subCategory) => subCategory.id === subCategoryId)) {
            return {
                ...category,
                subCategories: category.subCategories.map((subCategory) => {
                    if (subCategory.id === subCategoryId) {
                        if (subCategory.products.some(product => bulkProducts.some(p => p.uuid === product.uuid && p.orgId === product.orgId))) {
                            if (!isAllProductsSelected) {
                                //get products that are in bulkProducts and not in subCategory.products
                                const productsToAdd = bulkProducts.filter(p => !subCategory.products.some(product => product.uuid === p.uuid && product.orgId === p.orgId));
                                return {
                                    ...subCategory,
                                    products: [...subCategory.products, ...productsToAdd.map(p => ({ uuid: p.uuid, name: p.name, orgId: p.orgId }))]
                                }
                            }
                            return {
                                ...subCategory,
                                products: subCategory.products.filter((product) => !bulkProducts.some(p => p.uuid === product.uuid && p.orgId === product.orgId))
                            }
                        }
                        return { ...subCategory, products: [...subCategory.products, ...bulkProducts.map(p => ({ uuid: p.uuid, name: p.name, orgId: p.orgId }))] }
                    }
                    return subCategory;
                })
            }
        } else {
            return category;
        }
    })
    return updatedCategories;
}


export const categoryProductsUpdate = (categories, parentCategoryId, subCategoryId, currProduct) => {
    const updatedCategories = categories.map((category) => {
        if (category.parentCategory.id === parentCategoryId
            && category.subCategories.find((subCategory) => subCategory.id === subCategoryId)) {
            return {
                ...category,
                subCategories: category.subCategories.map((subCategory) => {
                    if (subCategory.id === subCategoryId) {
                        if (subCategory.products.some(product => product.orgId === currProduct.orgId && product.uuid === currProduct.uuid)) {
                            return {
                                ...subCategory,
                                products: subCategory.products.filter((product) => product.uuid !== currProduct.uuid)
                            }
                        }
                        return { ...subCategory, products: [...subCategory.products, { uuid: currProduct.uuid, name: currProduct.name, orgId: currProduct.orgId }] }
                    }
                    return subCategory;
                })
            }
        } else {
            return category;
        }
    })
    return updatedCategories;
}